const FEATURE_LEGACY_DOCUMENT_VAULT_DISABLED = 'LEGACY_DOCUMENT_VAULT_DISABLED';
const FEATURE_DOCUMENT_VAULT_FRA = 'DOCUMENT_VAULT_FRA';
const FEATURE_BUILDING_SAFETY_CASE = 'BUILDING_SAFETY_CASE';

export const FEATURE_ACTION_FINDER = 'VUE_APP_FEATURE_ACTION_FINDER';

import {
  PROPERTIES_VIEW_PROPERTIES,
  DOCUMENT_VAULT_ACCESS,
  ACTIONS_VIEW_URGENT_ACTIONS, BSC_VIEW_CASE, BSC_VIEW_ACTIONS,
} from '@/config/permission';


export function isFeatureEnabled(feature) {
  return process.env[feature] === '1' || process.env[feature] === 'true';
}

export function isDocumentVaultEnabled(user) {
  const { features } = user || {};

  if (!Array.isArray(features) || features.length === 0) {
    return false;
  }

  return features.includes(FEATURE_LEGACY_DOCUMENT_VAULT_DISABLED);
}

export function isDocumentVaultFRAEnabled(user) {
  const { features } = user || {};

  if (!Array.isArray(features) || features.length === 0) {
    return false;
  }

  return features.includes(FEATURE_DOCUMENT_VAULT_FRA);
}

export function isBuildingSafetyCaseEnabled(user) {
  const { features } = user || {};

  if (!Array.isArray(features) || features.length === 0) {
    return false;
  }

  return features.includes(FEATURE_BUILDING_SAFETY_CASE);
}

export function canUserAccessDocumentVault(user) {
  if (!isDocumentVaultEnabled(user)) {
    return false;
  }

  const permissions = user.roles.flatMap(r => r.permissions.map(p => p.name));

  if (!permissions.includes(PROPERTIES_VIEW_PROPERTIES) ||
    !permissions.includes(DOCUMENT_VAULT_ACCESS)) {
    return false;
  }

  return true;
}

export function canUserAccessDocumentVaultFRA(user) {
  if (!canUserAccessDocumentVault(user)) {
    return false;
  }

  if (!isDocumentVaultFRAEnabled(user)) {
    return false;
  }

  return true;
}

export function canUserAccessUrgentActions(user) {
  const permissions = user.roles.flatMap(r => r.permissions.map(p => p.name));

  return permissions.includes(ACTIONS_VIEW_URGENT_ACTIONS);
}

export function canUserAccessBSC(user) {
  if (!isBuildingSafetyCaseEnabled(user)) {
    return false;
  }

  const permissions = user.roles.flatMap(r => r.permissions.map(p => p.name));

  return permissions.includes(BSC_VIEW_CASE);
}
